import { useEffect } from 'react';

/**
 * Radix sets `pointer-events: none` on the body while a dialog is open, which
 * breaks a lot of components.
 * https://github.com/radix-ui/primitives/issues/2122#issuecomment-2205128989
 *
 * Called by `ModalRoot`, so every surface built on it is covered without having
 * to opt in.
 */
export const useBodyPointerEvents = (isOpen: boolean) => {
  useEffect(() => {
    if (isOpen) {
      // Pushing the change to the end of the call stack
      const timer = setTimeout(() => {
        document.body.style.pointerEvents = '';
      }, 0);

      return () => clearTimeout(timer);
    } else {
      document.body.style.pointerEvents = 'auto';
    }
  }, [isOpen]);
};
